// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3SWgZ","inputWrap":"Table_inputWrap__hHvdA","col":"Table_col___NSCJ","bmiTooltip":"Table_bmiTooltip__fx9Hr"};